import Blog from "components/Blog";

const ProductDescriptions = () => {

    return (
        <Blog id={"min-bedrift-produktbeskrivelse"}></Blog>
    )

}

export default ProductDescriptions;